export default __webpack_public_path__ + "0d9c89987f6b76e6005d2a5f61ef764d.png";